import { Card, CardContent, CardFooter } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { MASTERCLASS_COVER_ASPECT_CLASS } from "@/lib/masterclass-cover"

/**
 * OKS-56 / OKS-836 — Creator-side masterclass card loading skeleton
 * (UX Spec §3 Loading state — three of these stack to match the
 * populated card layout, preventing layout-shift on first paint).
 *
 * OKS-836 reshaped this to match the redesigned banner card: a
 * full-width 3:2 banner block (the shared `MASTERCLASS_COVER_ASPECT_CLASS`
 * — same footprint the resolved cover/swatch fills, so the
 * shimmer→content swap is pixel-stable) over the title / topic /
 * description lines + the footer pill. The old 56px-square skeleton would
 * now mis-match the taller banner card and shift on load.
 */
export function CreatorMasterclassCardSkeleton() {
  return (
    <Card
      className="flex flex-col gap-0 overflow-hidden p-0"
      data-testid="learn-card-skeleton"
      aria-busy="true"
      aria-live="polite"
    >
      <Skeleton
        className={`${MASTERCLASS_COVER_ASPECT_CLASS} w-full rounded-none`}
      />
      <CardContent className="flex flex-col gap-2 p-4">
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-3 w-2/5" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-3/4" />
      </CardContent>
      <CardFooter className="p-4 pt-0">
        <Skeleton className="h-5 w-24 rounded-full" />
      </CardFooter>
    </Card>
  )
}
